module.exports = __webpack_public_path__ + "4e8b0592553812458c9e328b4388f0e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-2.jpg
// module id = 1202
// module chunks = 0